<template lang="pug">
  b-container
    b-form-row.align-items-center.mt-3.mb-4
      b-col.mb-2.mb-md-0
        h4.mb-0 Contactos
      b-col(md="auto")
        b-button(variant="primary" @click="contact_modal = true") Crear contacto
    b-card(no-body)
      template(slot="header")
        b-form-row.align-items-center
          b-col.mb-2.mb-md-0
            b-input-group
              b-form-input(type="search", placeholder="Buscar contacto...", v-model="search_text")
              b-input-group-append
                b-input-group-text
                  search-icon.text-dark.icon-sm
          b-col(cols="auto")
            b-dropdown(ref="dropdown_filter", right, variant="light", no-caret, :menu-class="['filters-dropdown']")
              template(slot="button-content")
                filter-icon.icon-sm
              b-dropdown-header Filtrar contactos
              b-dropdown-form
                b-form-radio-group(v-model="filter_assigned", :options="filter_options", stacked)
      b-table.mb-0(ref="contacts_table", :fields="fields", :items="contacts", responsive, show-empty, :busy="loading", selectable, select-mode="single", selectedVariant="secondary", @row-selected="selectContact")
        template(v-slot:empty)
          p.mb-0.text-center.text-help {{search_text.length ? 'No hay coincidencias' : 'No hay contactos creados'}}
        template(v-slot:table-busy)
          .text-center
            b-spinner(variant="primary")
        template(v-slot:cell(full_name)="{ item, value }")
          .d-flex.align-items-start
            b-link.flex-grow-1(@click.stop="selectContact([item])") {{value}}
              .text-secondary.text-sm {{item.email}}
            b-dropdown(v-if="item.platforms && item.platforms.length", no-caret, size="sm", variant="link")
              template(slot="button-content")
                message-circle-icon.icon-md
              b-dropdown-header Conversaciones
              b-dropdown-item(v-for="(platform, index) in item.platforms", :key="index", @click="openConversation(platform)") {{platform.title}}
        template(v-slot:cell(admin)="{ item, value }")
          b-link(@click.stop="toggleAdminModal(item, value)") {{value ? value.email : 'Sin asignar'}}
        template(v-slot:cell(stage)="{ item, value }")
          b-dropdown(size="sm", :text="value ? stages[value] : stages.created", :variant="value === 'closed' ? 'light' : 'primary'" :menu-class="['filters-dropdown']")
            b-dropdown-header Etapa
            b-dropdown-form
              b-form-radio-group(v-model="item.stage", :options="stage_options", @change="updateContact({stage: $event}, item._id)", stacked)
        template(v-slot:cell(tag)="{ item, value }")
          b-dropdown(size="sm", v-bind="value ? tags[value] : tags.client", :menu-class="['filters-dropdown']")
            b-dropdown-header Etiqueta
            b-dropdown-form
              b-form-radio-group(v-model="item.tag", :options="tag_options", @change="updateContact({tag: $event}, item._id)", stacked)
        template(v-slot:cell(createdAt)="{ value }")
          div {{value ? $moment(value).format('DD MMMM YYYY') : 'No disponible'}}
      .d-flex.align-items-center.card-body
        b-pagination.mb-0(:total-rows="v_paginationItemsCount", :per-page="v_paginationLimit", :value="paginationCurrentPage", @change="paginationPageChanged($event, 'getContacts')", v-if="v_paginationShow")
        b-spinner.ml-3(small, variant="primary", v-if="loading")
        //template(v-slot:cell(first_name)="{ item }")
          .d-flex.align-items-center.hidden-md-and-down
            .flex-grow-1
              p.mb-0 {{ item.full_name }}
              p.mb-0.text-secondary {{ item.email }}
            chevron-right-icon

    SideModal(v-model="side_modal", size="lg", @input="side_modal = false")
      template(v-if="side_modal")
        Contact(:contact_id="contact_id")
    // ASIGN ADMIN MODAL
    b-modal(v-model="admin_modal", size="lg", title="Reasignar administrador", cancel-title="Cancelar", ok-title="Guardar", ok-variant="primary", @ok="assignAdmin", :ok-disabled="!admin_selected", scrollable)
      b-input-group.mb-3
        b-form-input(placeholder="Buscar admin...", v-model="search_admin", type="search")
        b-input-group-append
          b-input-group-text
            search-icon.text-secondary.icon-sm
      b-table.table-nowrap.mb-0.scrollable-area.mt-2(:items="admins", :fields="admin_fields", responsive, :filter="search_admin", selectable, select-mode="single", @row-selected="selectAdmin", selectedVariant="secondary", :ref="'admins_table'")
        template(v-slot:empty)
          p.text-help.mb-0.text-center.my-4 {{search_admin ? 'No hay coincidencias' : 'No hay admins'}}
        template(v-slot:cell(name)="{ item }") {{ item.first_name }} {{ item.last_name }}
    b-modal(v-model="contact_modal", centered, size="lg", title="Crear contacto", cancel-title="Cancelar", ok-title="Crear", ok-variant="success", @ok="createContact", @hidden="resetModal")
      b-container(fluid)
        b-form-row.mb-3
          b-col(md="6")
            b-form-group(label="Nombre", label-size="sm")
              b-input-group
                b-input-group-prepend
                  b-form-select.border-right-0(v-model="contact_data.title")
                    option.text-secondary(value="", disabled) Título
                    option(v-for="t in titles", :key="t", :value="t") {{t}}
                b-form-input(v-model="contact_data.first_name" name="name" placeholder="Nombre", trim, :state="contact_data.first_name ? null : (data_validated ? false : null)")
          b-col(md="6")
            b-form-group(label="Apellido", label-size="sm")
              b-form-input(v-model="contact_data.last_name", placeholder="Apellido", trim, :state="contact_data.last_name ? null : (data_validated ? false : null)")
        b-form-group(label="Correo", label-size="sm")
          b-form-input(v-model="contact_data.email", name="email", placeholder="Correo", trim, :state="contact_data.email ? null : (data_validated ? false : null)")
        b-form-row.mb-3
          b-col(md="6")
            b-form-group(label="Num. teléfono", label-size="sm")
              b-form-input(v-model="contact_data.phone", placeholder="Teléfono", trim)
          b-col(md="6")
            b-form-group(label="Num. celular", label-size="sm")
              b-form-input(v-model="contact_data.cell_phone", placeholder="Celular", trim)
        b-form-group(label="Empresa", label-size="sm")
          b-form-input(v-model="contact_data.commercial_name", placeholder="Empresa", trim)
        b-form-group(label="Plataforma principal", description="Plataforma por donde es más fácil contactar a la persona")
          b-form-select(v-model="contact_data.main_platform")
            option(value="", disabled) -- Seleccionar plataforma --
            option(v-for="plat in platforms", :key="plat.platform_id", :value="plat.name") {{plat.title}}
</template>

<script>
import Toolbar from "@/components/Toolbar";
import Contact from '../../components/Contact.vue'
import _debounce from 'lodash.debounce'
import { createNamespacedHelpers, mapActions } from 'vuex'
const accountController = createNamespacedHelpers('account')
const platformController = createNamespacedHelpers('platform')
const contactController = createNamespacedHelpers('contact')

export default {
  data () {
    return {
      loading: false,
      search_text: '',
      search_admin: '',
      admin_modal: false,
      contact_modal: false,
      side_modal: false,
      contact_id: null,
      admin_selected: null,
      titles: ['Sra.', 'Srta.', 'Sr.', 'Lda.', 'Ldo.', 'Dra.', 'Dr.'],
      data_validated: false,
      admin_fields: [
        { key: 'name',  label: 'Nombre' },
        { key: 'email',  label: 'Email' },
      ],
      fields: [
        { key: 'full_name', label: 'Contacto' },
        //{ key: 'email', label: 'Correo' },
        { key: 'phone', label: 'Teléfono' },
        { key: 'admin', label: 'Asesor' },
        { key: 'stage', label: 'Etapa' },
        { key: 'tag', label: 'Etiqueta' },
        { key: 'createdAt', label: 'Fecha de creación' },
      ],
      stages: {
        created: "Nuevo",
        qualified: "Evaluado",
        contacted: "Contactado",
        negotiation: "En negociación",
        closed: "Cerrado"
      },
      stage_options: [
        { text: 'Nuevo', value: 'created' },
        { text: 'Evaluado', value: 'qualified' },
        { text: 'Contactado', value: 'contacted' },
        { text: 'En negociación', value: 'negotiation' },
        { text: 'Cerrado', value: 'closed' }
      ],
      tags: {
        client: {text: "Cliente", variant: "info"},
        high: {text: "Muy interesado", variant: "success"},
        medium: {text: "Algo interesado", variant: "warning"},
        low: {text: "Poco interesado", variant: "danger"},
      },
      tag_options: [
        { text: 'Cliente', value: 'client' },
        { text: 'Muy interesado', value: 'high' },
        { text: 'Algo interesado', value: 'medium' },
        { text: 'Poco interesado', value: 'low' }
      ],
      filter_assigned: "all",
      filter_options: [
        { text: 'Todos', value: 'all' },
        { text: 'Mis contactos', value: 'me' },
        { text: 'Sin asignar', value: 'unassigned' },
      ],
      contact_data: {
        first_name: '',
        last_name: '',
        commercial_name: '',
        email: '',
        phone: '',
        cell_phone: '',
        title: '',
        main_platform: '',
      },
    }
  },
  computed: {
    ...platformController.mapState({
      platforms: state => state.all_platforms
    }),
    ...contactController.mapState({
      contacts: state => state.contacts
    }),
    ...accountController.mapState({
      admins: state => state.admins
    })
  },
  methods: {
    ...mapActions(['account/admins', 'platform/index', 'contact/all', 'contact/create', 'contact/update']),
    getAdmins () {
      let self = this

      this['account/admins']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    },
    getPlatforms () {
      let self = this
      this['platform/index']({
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      });
    },
    getContacts () {
      this.loading = true
      let self = this

      let params = {
        ...this.paginationParamsObject,
        filter_assigned: this.filter_assigned
      }

      if (this.search_text) params.search = this.search_text

      this['contact/all']({
        account_id: self.$route.params.account_id,
        params,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parsePaginationDataFromResponse(res)
          }
        }
      });
    },
    createContact (bvModalEvt) {
      let requiered = ['first_name', 'last_name', 'email']
      for(let key in this.contact_data) {
        if(requiered.includes(key) && !this.contact_data[key]) {
          bvModalEvt.preventDefault()
          this.data_validated = true
          return
        }
      }

      this.loading = true
      let self = this
      this['contact/create']({
        account_id: self.$route.params.account_id,
        ...self.contact_data,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Contacto creado')
          }
        }
      });
    },
    searchContact: _debounce(function () {
      this.getContacts()
    },1000, {leading: false, trailing: true}),
    selectContact (items) {
      this.contact_id = items[0]._id
      this.side_modal = true
    },
    resetModal () {
      for (let key in this.contact_data) {
        this.contact_data[key] = ''
      }
      this.data_validated = false
    },
    toggleAdminModal (contact, admin) {
      this.contact_id = contact._id
      this.admin_modal = true
      if(admin) {
        this.admin_selected = admin
        let index = this.admins.findIndex(el => el.admin_id === admin.admin_id)
        this.$nextTick(() => {
          this.$refs.admins_table.selectRow(index)
        })
      }
    },
    selectAdmin (items) {
      this.admin_selected = items[0]
    },
    assignAdmin () {
      this.updateContact({
        assigned_admin_id: this.admin_selected.admin_id,
        contact_id: this.contact_id
      })
    },
    updateContact (data, contact_id) {
      let self = this
      this['contact/update']({
        contact_id: contact_id,
        ...data,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Contacto actualizado')
          }
        }
      });
    },
    openConversation ({conversation_id}) {
      let route = this.$router.resolve({
        name: 'Conversation',
        params: { conversation_id: conversation_id }
      })
      window.open(route.href, '_blank');
    }
  },
  mounted () {
    this.getAdmins()
    this.getPlatforms()
    this.getContacts()
    let self = this;
    let scrollFunction = function () {
      let top = $(this).scrollTop()

      if (top + this.clientHeight >= this.scrollHeight && self.pagination_hasNextPage) {
        self.loading = true
        self.getContacts()
      }
    }

    $('#contacts-list').on('scroll', scrollFunction)
    $('#router-container').on('scroll', scrollFunction)
  },
  watch: {
    search_text () {
      this.resetPagination()
      this.searchContact()
    },
    filter_assigned () {
      this.resetPagination()
      this.getContacts()
    }
  },
  components: { Toolbar, Contact }
}
</script>

<style lang="scss" scoped>
  .border-right-0 {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
</style>
